'use client'

import type { CSSProperties } from 'react'
import { ThemeToggle } from './ThemeToggle'
import { useUserPermissions } from '@/hooks/useUserPermissions'

type AdminThemeToggleProps = {
  className?: string
  style?: CSSProperties
  forMobileNavbar?: boolean
}

export function AdminThemeToggle(props: AdminThemeToggleProps) {
  const { userRoles, isLoading } = useUserPermissions()
  if (isLoading || !userRoles?.includes('admin')) {
    return null
  }
  return <ThemeToggle {...props} />
}
